module.exports = __webpack_public_path__ + "static/img/5680944cb49df79937b382bdeb20a181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_tphy.png
// module id = lKVK
// module chunks = 1